<template>
  <div
    :class="[
      'nc-list-item tw-flex tw-items-center tw-min-h-[44px] tw-px-4 tw-py-2 tw-gap-3',
      clickable ? 'tw-cursor-pointer active:tw-bg-black/5 dark:active:tw-bg-white/5' : '',
    ]"
    :style="lines === 'inset' ? borderStyle : {}"
    @click="clickable ? $emit('click', $event) : null"
  >
    <div v-if="$slots.start" class="tw-flex tw-items-center tw-shrink-0">
      <slot name="start" />
    </div>
    <div class="tw-flex-1 tw-min-w-0">
      <slot />
    </div>
    <div v-if="$slots.end" class="tw-flex tw-items-center">
      <slot name="end" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NcListItem',
  props: {
    clickable: { type: Boolean, default: false },
    lines: { type: String, default: 'inset', validator: v => ['inset', 'none'].includes(v) },
  },
  emits: ['click'],
  computed: {
    borderStyle() {
      return { borderBottom: '1px solid var(--nc-border, #e8e8e8)' };
    },
  },
};
</script>
<style scoped>
@media (max-width: 480px) {
    .nc-list-item {
        padding-left: 10px;
        padding-right: 10px;
        gap: 8px;
    }
}
</style>
